export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8150.7222d0ee.jpg";